import { Idea } from '@frontend/data-access';
import { IdeaChannelCard } from '@frontend/feature-idea-channel';
import { Draggable } from '@hello-pangea/dnd';

export type ItemType = {
  index: number;
  data: Idea;
  isDataFetching: boolean;
};

const KanbanItem = ({ index, data, isDataFetching }: ItemType) => {
  return (
    <Draggable
      key={data.id}
      draggableId={data.id}
      index={index}
      isDragDisabled={isDataFetching}
    >
      {(provided, snapshot) => (
        <div
          className={`
          ${isDataFetching ? 'cursor-wait ' : 'cursor-pointer '}
            ${
              snapshot.isDragging ? 'shadow opacity-80' : ''
            } p-3 rounded-lg border border-gray-400 bg-gray-200 mb-2 w-56 hover:border-primary-600 transition-all duration-500 ease-in-out`}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <IdeaChannelCard key={index} data={data} />
        </div>
      )}
    </Draggable>
  );
};

export default KanbanItem;
